<template>
  <div class="hero">
    <h1 :class="startpage && 'startpage'" v-html="heading" />
    <img
      :src="heroBackgroundImage
        ? '/images/hero/' + heroBackgroundImage
        : '/images/hero/visual-identity.jpg'"
      :class="noBackgroundImage ? 'displayNone' : 'heroBackgroundImage'"
    />
    <img
      class="heroRightSideImage"
      :src="heroRightSideImage && '/images/hero/' + heroRightSideImage"
    />
    <img
      class="heroLeftSideImage"
      :src="heroLeftSideImage && '/images/hero/' + heroLeftSideImage"
    />
    <div :class="heroOverlay ? heroOverlay : 'mediumOverlay'" />
  </div>
</template>

<script>
export default {
  name: 'Hero',
  props: ['startpage', 'heroBackgroundImage', 'heroRightSideImage', 'heroLeftSideImage', 'noBackgroundImage', 'heading', 'heroOverlay', 'tagline'],
};
</script>
<style lang="stylus" scoped>
  @require '../style/colors'

  .hero
    position: relative
    display: flex
    justify-content: center
    align-items: center
    flex-direction: column
    height: 43rem
    text-align: center
    background-color: $secondary-color
    color: #fff

  h1
    position: absolute
    margin: 0
    font-size: 86px
    font-weight: 700
    line-height: 96px
    z-index: 2

  .startpage
    max-width: 700px
    color: $primary-color

    @media only screen and (max-width: 400px)
      font-size: 7rem
      line-height: 8.3rem

  .heroBackgroundImage
    width: 100%
    height: 100%
    object-fit: cover

  .heroRightSideImage
    position: absolute
    top: 0
    right: 0
    height: 100%

    @media only screen and (max-width: 1100px)
      display: none

  .heroLeftSideImage
    position: absolute
    top: 40px
    left: 0
    height: 155%

    @media only screen and (max-width: 1100px)
      top: 60px
      height: 120%

    @media only screen and (max-width: 980px)
      display: none

  .heroOverlay
    position: absolute
    background-color: $primary-color
    width: 100%
    height: 100%

  .displayNone
    display: none

  .lightOverlay
    @extend .heroOverlay
    opacity: 0.2

  .mediumOverlay
    @extend .heroOverlay
    opacity: 0.6

</style>
